<template>
    <div class="contract-operation">
        <div class="mt-8 flex items-center">
            <h1 v-show="operation==='add'" class="font-bold page-title">新增合同</h1>
            <h1 v-show="operation==='edit'" class="font-bold page-title">编辑合同</h1>
            <div class="ml-auto">
                <button class="button button--bg mr-1 mb-2 border border-theme-1 text-theme-1 dark:bg-dark-5 dark:text-gray-300" @click="backHandle">返回</button>
                <button class="button button--bg mr-1 mb-2 bg-theme-1 text-white" type='primary' @click="complete">创建完成</button>
            </div>
        </div>
        <div class="mt-5 intro-y box border border-gray-200 dark:border-dark-5 rounded-md p-5">
            <contract-and-rent-edit ref="contractRentEdit"></contract-and-rent-edit>

            <remark-edit name="合同备注：" :remarkVal.sync='remark'></remark-edit>

            <asset-appendix class="mt-5" name="合同附件" @getAppendixList='getAppendixList' :data.sync='appendixList'></asset-appendix>
        </div>
    </div>
</template>
<script>
import contractAndRentEdit from './components/contractOperation/contractAndRentEdit.vue'
import remarkEdit from './components/assetDetail/coms/remarkEdit.vue'
import assetAppendix from './components/assetOperation/assetAppendix.vue'
import {addOrModContract,contractEditDetail} from '@/api/asset.js'
export default {
    name:'contractOperation',
    data(){
        return{
            remark:'',
            appendixList:[],
            id:'',
            operation:'add',
            assetId:'',
        }
    },
    components:{
        contractAndRentEdit,
        remarkEdit,
        assetAppendix,
    },
    methods:{
        backHandle(){
            this.$router.go(-1)
        },
        getAppendixList(val){
            this.appendixList=val;
        },
        getDetail(){
            contractEditDetail({id:this.id}).then(res=>{
                let data=res.data;
                if(data.code==='000'){
                    this.$refs.contractRentEdit.form=data.content;
                    this.remark=data.content.contractRemark;
                    this.appendixList=data.content.contractFile||[];
                }else{
                    console.log(data.desc);
                }
            })
        },
        complete(){
            this.$refs.contractRentEdit.$refs.ruleForm2.validate(valid=>{
                if (valid) {
                    let resForm = this.$refs.contractRentEdit.form;
                    let startDate=new Date(resForm.contractStartDate);
                    let endDate=new Date(resForm.contractEndDate);
                    if(startDate>=endDate){
                        this.$message.warning('合同结束日期必须大于合同开始日期')
                        return;
                    }
                    console.log(resForm)
                    if(resForm.rentCollectionInterval==='SEASON' && resForm.leaseTerm<3){
                        this.$message.warning('租赁期限不能小于3个月')
                        return;
                    }
                    if(resForm.rentCollectionInterval==='HALF_A_YEAR' && resForm.leaseTerm<6){
                        this.$message.warning('租赁期限不能小于6个月')
                        return;
                    }
                    if(resForm.rentCollectionInterval==='ONE_YEAR' && resForm.leaseTerm<12){
                        this.$message.warning('租赁期限不能小于12个月')
                        return;
                    }
                    
                    let para=JSON.parse(JSON.stringify(resForm))
                    para.contractRemark=this.remark;
                    para.contractFile=this.appendixList;
                    para.assetId=this.assetId;
                    para.id=this.id;
                    addOrModContract(para).then(res=>{
                        let data=res.data;
                        if(data.code==='000'){
                            this.$message.success(data.desc)
                            this.$router.go(-1)
                        }else{
                            console.log(data.desc);
                            this.$message.warning(data.desc)
                        }
                    })
                } else {
                    console.log('error submit!!');
                    console.log(valid,444)
                    return false;
                }

            })

        }
    },
    created(){
        this.operation=this.$route.query.operation;
        this.assetId=this.$route.query.assetId;
        if(this.$route.query.operation==='edit'){
            this.id=this.$route.query.id;
            this.getDetail();
        }
    }
}
</script>
<style lang="scss" scoped>
// .contract-operation{
//     .asset-page-title{
//         display: flex;
//         justify-content: space-between;
//     }
// }
</style>


